import request from '@ps/utils/request'

export function getScriptList(data) {
  return request({
    url: '/ps/script/list',
    method: 'get',
    params: data,
  })
}
